import React, {Component} from 'react';
import {connect} from 'react-redux';
import Action from 'components/organisms/dominator-stacking/actions';
import Const from 'constants';

class Settings extends Component {
    constructor(props) {
        super(props);
        this.signature = null;
        this.state = {
            type: Const.STACKS_TYPE_AT_LEAST,
            numberPlayers: 0,
        };
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const {stacking} = this.props;
        if (stacking.getSignature() !== this.signature) {
            this.signature = stacking.getSignature();
            this.setState({
                type: Const.STACKS_TYPE_AT_LEAST,
                numberPlayers: 0,
            });
        }
    }

    selectType(e) {
        this.setState({type: e.target.value});
    }

    selectNumberPlayers(e) {
        this.setState({numberPlayers: Number(e.target.value)});
    }

    addStack() {
        const {...settings} = {...this.state};
        this.props.dispatch(Action.do('addItemToPlayerDominatorStacking', settings));
    }

    render() {
        const {stacking} = this.props;

        return (
            <div className="white-box">
                <h3>Create New Rule</h3>
                <div className="gray-holder">
                    <div className="form-inline">
                        <div className="form-text">Stack</div>
                        <select
                            onChange={(e) => ::this.selectType(e)}
                            value={this.state.type}
                            className="form-control input-md"
                        >
                            <option value={Const.STACKS_TYPE_AT_LEAST}>At least</option>
                            <option value={Const.STACKS_TYPE_EXACTLY}>Exactly</option>
                            <option value={Const.STACKS_TYPE_AT_MOST}>At most</option>
                        </select>
                        <select
                            onChange={(e) => ::this.selectNumberPlayers(e)}
                            value={this.state.numberPlayers}
                            className="form-control input-md"
                        >
                            <option value={0}>0 Players</option>
                            <option value={1}>1 Player</option>
                            <option value={2}>2 Players</option>
                            <option value={3}>3 Players</option>
                            <option value={4}>4 Players</option>
                        </select>
                        {isEmpty(stacking.hasItems()) ? (
                            <button type="submit" onClick={::this.addStack} className="btn">
                                Add Rule
                            </button>
                        ) : null}
                    </div>
                </div>
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {dominatorStacking} = state;
    return {
        stacking: dominatorStacking,
    };
}

export default connect(mapStatesToProps)(Settings);
